import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompare = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M16.2803 12.2193L21.2203 17.1593C21.3252 17.2642 21.4589 17.3355 21.6044 17.3644C21.7499 17.3932 21.9007 17.3783 22.0377 17.3214C22.1747 17.2646 22.2918 17.1684 22.3741 17.045C22.4565 16.9217 22.5004 16.7767 22.5003 16.6283V6.75034C22.5004 6.60201 22.4565 6.457 22.3741 6.33363C22.2918 6.21026 22.1747 6.11408 22.0377 6.05724C21.9007 6.00041 21.7499 5.98547 21.6044 6.01433C21.4589 6.04318 21.3252 6.11452 21.2203 6.21934L16.2803 11.1593C16.2106 11.2289 16.1554 11.3115 16.1177 11.4025C16.08 11.4934 16.0605 11.5909 16.0605 11.6893C16.0605 11.7878 16.08 11.8853 16.1177 11.9762C16.1554 12.0672 16.2106 12.1498 16.2803 12.2193Z",
		stroke: "currentColor",
		fill: "none",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.72 12.2193L2.78 17.1593C2.67505 17.2642 2.54138 17.3355 2.39589 17.3644C2.2504 17.3932 2.09962 17.3783 1.96261 17.3214C1.82561 17.2646 1.70854 17.1684 1.62619 17.045C1.54385 16.9217 1.49993 16.7767 1.5 16.6283V6.75034C1.49993 6.60201 1.54385 6.457 1.62619 6.33363C1.70854 6.21026 1.82561 6.11408 1.96261 6.05724C2.09962 6.00041 2.2504 5.98547 2.39589 6.01433C2.54138 6.04318 2.67505 6.11452 2.78 6.21934L7.72 11.1593C7.78966 11.2289 7.84493 11.3115 7.88264 11.4025C7.92035 11.4934 7.93975 11.5909 7.93975 11.6893C7.93975 11.7878 7.92035 11.8853 7.88264 11.9762C7.84493 12.0672 7.78966 12.1498 7.72 12.2193Z",
		stroke: "currentColor",
		fill: "none",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 18.5V5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgCompare;
